import React from 'react';
import { Col, Row } from 'antd';
import Button from '../../views/StyledButton';
import VBQLArea from '../../views/VBQLArea';

export default ({
  chooseActiveField, activeField, chooseQueryFrom, queryModel, tabKey,
}) => (
  <React.Fragment>

    <div onClick={() => chooseActiveField('from')}>From</div>
    {activeField !== 'from' ? '' : (
      <Row gutter={0} style={({ marginBottom: '0.5rem' })}>
        <Col xs={24} sm={12} md={9}>
          <Button
            type="default"
            size="small"
            onClick={() => chooseQueryFrom('media')}
          >media
          </Button>
        </Col>
      </Row>
    )}
    {activeField === 'from' ? (
      <div className="cm-size-50">
        {tabKey !== 'queryDivided' ? '' : <VBQLArea
          placeholder="enter the 'FROM' part of your query"
          value={queryModel.from}
          onChange={chooseQueryFrom}
        />}
      </div>
    ) : (
      <div className="query-clickable" onClick={() => chooseActiveField('from')}>
        {queryModel.from || <span>&nbsp;</span>}
      </div>
    )}
  </React.Fragment>
);
